<template>
  <img
    :src="iconPath"
    :class="customClass"
    :style="{ fill: color, width: '24px', height: '24px' }"
    alt="svg icon"
  />
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: { type: String, required: true },
    color: { type: String, default: '#000' },
    customClass: { type: String, default: '' }
  },
  computed: {
    iconPath() {
      return require(`assets/sidebar-icons/${this.icon}.svg`)
    }
  }
}
</script>


<style scoped>
svg {
  width: 24px;
  height: 24px;
  display: inline-block;
}
</style>
